import clsx from 'clsx';
import { ServerProduct } from '@/lib/janitsjar/Product';

export type KeyPropertiesProps = {
  product: ServerProduct;
};

export function KeyProperties({ product }: KeyPropertiesProps) {
  if (!product) return null;

  return (
    <table className={clsx('border-collapse', 'w-full')}>
      <tbody className="print:columns-2 print:gap-10 print:break-before-avoid-page print:block print:w-full">
        {product.properties.map((property, index) => {
          return (
            <tr
              key={property.key}
              className={clsx({
                'bg-neutral-30 print:bg-[transparent]': index % 2 === 1,
              })}
            >
              <th
                className={clsx(
                  'text-left',
                  'hd-base',
                  'p-4 pr-5',
                  'print:p-1',
                  'print:pl-0',
                  'print:hd-xs',
                  'print:w-1/3'
                )}
              >
                {property.label}
              </th>
              <td
                className={clsx(
                  'p-4 body-base',
                  'print:p-1',
                  'print:body-xs',
                  'print:w-2/3'
                )}
              >
                {property.value} {property.unit}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default KeyProperties;
